import {
  deleteManagedResourceType,
  getApplicationListV2,
  getManagedResourceTypesInApplication,
  getServiceApplicationsInServiceCollection,
  getServiceApplicationSubscriptionSettings,
  postCreateManagedResourceType,
  putUpdateManagedResourceType,
} from "../../actions/api";
import { getServiceCollection } from "../../actions/api";
import React, { useEffect, useState } from "react";
import {
  Button,
  Tooltip,
  List,
  Badge,
  Popconfirm,
  Divider,
  Breadcrumb,
} from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ApplicationHeader, ServiceHeader } from "../headers/PageHeaders";
import { ErrorBar } from "@authzsvc/common-react-components";
import { EditOutlined } from "@ant-design/icons";
import { applicationPortal } from "../../config";
import { Typography } from "antd";
import {
  DatabaseOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons/lib";
import { HelpManagedResourceType } from "./help/HelpManagedResourceType";
import { useParams } from "react-router";
import { Link, NavLink } from "react-router-dom";
import { ManagedResourceTypeEditModal } from "./ManagedResourceTypeForm";

const { Title } = Typography;

const ServiceApplicationManagedResourceTypeAdmin = ({
  getServiceCollection,
  getApplicationListV2,
  getServiceApplicationsInServiceCollection,
  getServiceApplicationSubscriptionSettings,
  serviceCollection,
  serviceApplications,
  applications,
  applicationSettings,
  isLoading,
  getManagedResourceTypesInApplication,
  loading,
  resourceTypes,
  postCreateManagedResourceType,
  putUpdateManagedResourceType,
  deleteManagedResourceType,
}) => {
  const { serviceCollectionId, applicationId } = useParams();
  const [serviceCollectionIsAdmin, setServiceCollectionIsAdmin] =
    useState(false);
  const [applicationIsAdmin, setApplicationIsAdmin] = useState(false);
  const [application, setApplication] = useState(false);

  useEffect(() => {
    if (applicationId) getManagedResourceTypesInApplication(applicationId);
  }, [getManagedResourceTypesInApplication, applicationId]);

  useEffect(() => {
    if (application)
      getServiceApplicationSubscriptionSettings(
        application.applicationIdentifier,
      );
  }, [getServiceApplicationSubscriptionSettings, application]);

  useEffect(() => {
    if (serviceApplications) {
      const tmpApp = serviceApplications.find(
        (x) => applicationId === x.applicationIdentifier,
      );
      if (tmpApp) setApplication(tmpApp);
      setApplicationIsAdmin(true);
    }
  }, [serviceApplications, applicationId]);

  useEffect(() => {
    if (serviceCollectionIsAdmin)
      getServiceApplicationsInServiceCollection(serviceCollectionId);
  }, [
    getServiceApplicationsInServiceCollection,
    serviceCollectionIsAdmin,
    serviceCollectionId,
  ]);

  useEffect(() => {
    if (serviceCollection)
      setServiceCollectionIsAdmin(
        applications.some(
          (x) =>
            serviceCollection.applicationIdentifier === x.applicationIdentifier,
        ),
      );
  }, [serviceCollection, applications]);

  useEffect(() => {
    getApplicationListV2();
    getServiceCollection(serviceCollectionId);
  }, [getServiceCollection, serviceCollectionId, getApplicationListV2]);

  const onCreateFinish = async (values) => {
    await postCreateManagedResourceType(values);
    await getManagedResourceTypesInApplication(applicationId);
  };
  const onCreateFinishFailed = (errorInfo) => {
    console.log("Create Failed:", errorInfo);
  };

  const onUpdateFinish = async (values) => {
    await putUpdateManagedResourceType(values.id, values);
    await getManagedResourceTypesInApplication(applicationId);
  };
  const onUpdateFinishFailed = (errorInfo) => {
    console.log("Update Failed:", errorInfo);
  };

  const confirmDelete = async (id) => {
    await deleteManagedResourceType(id);
    await getManagedResourceTypesInApplication(applicationId);
  };

  if (!(serviceCollectionIsAdmin || applicationIsAdmin)) {
    return (
      <ErrorBar
        errors={[
          {
            title: "Access Denied.",
            data: {
              message:
                "You are not administrator of this Service Collection or this Application.",
            },
          },
        ]}
        dismissError={() => {
          window.location.href = "/";
        }}
      />
    );
  } else
    return (
      <div>
        <Breadcrumb
          items={[
            {
              title: <NavLink to="/manage">Service Collections</NavLink>,
            },
            {
              title: (
                <NavLink
                  to={`/manage/${serviceCollection?.applicationIdentifier}`}
                >
                  Service Applications for{" "}
                  {serviceCollection?.applicationIdentifier}
                </NavLink>
              ),
            },
            {
              title: `Managed Resource Types for ${application?.applicationIdentifier}`,
            },
          ]}
        />
        <ServiceHeader
          title={serviceCollection?.displayName}
          subTitle={serviceCollection?.description}
          loading={isLoading}
        />

        <ApplicationHeader
          title={application?.displayName}
          subTitle={application?.description}
          loading={isLoading}
          button={
            <Tooltip title="Edit this Application in the Application Portal">
              <Button
                icon={<EditOutlined />}
                href={`${applicationPortal}manage/${application?.applicationIdentifier}`}
                target="_blank"
              />
            </Tooltip>
          }
        />

        <Title level={5}>
          <DatabaseOutlined />
          &nbsp;Managed Resource Types
        </Title>

        <List
          loading={loading}
          dataSource={resourceTypes}
          renderItem={(item) => (
            <List.Item
              actions={[
                <ManagedResourceTypeEditModal
                  key={`zz0-${item.id}`}
                  title="Edit Managed Resource Type"
                  initialValues={item}
                  onFinish={onUpdateFinish}
                  onFinishFailed={onUpdateFinishFailed}
                />,
                <Tooltip
                  key={`zz1-${item.id}`}
                  title="Delete this Managed Resource Type"
                >
                  <Popconfirm
                    title="Delete the Managed Resource Type"
                    description={
                      <>
                        Are you sure to delete this managed resource type ?
                        <br />
                        All associated resources will become orphaned !
                      </>
                    }
                    onConfirm={() => confirmDelete(item.id)}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="Cancel"
                  >
                    <Button danger icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>,
              ]}
            >
              <List.Item.Meta
                title={item.resourceTypeName}
                description={
                  <>
                    Status:{" "}
                    {item.initialState === "Active" ? (
                      <Badge status="success" text="Active" />
                    ) : (
                      <Badge status="warning" text="Created" />
                    )}
                    <br />
                    Create Resource URL:{" "}
                    <Link href={item.createResourceUrl} target="_blank">
                      {item.createResourceUrl}
                    </Link>
                    <br />
                    Manage Resource URL template:{" "}
                    <Link href={item.managementUrlTemplate} target="_blank">
                      {item.managementUrlTemplate}
                    </Link>
                    <br />
                    Access Resource URL template:{" "}
                    <Link href={item.accessUrlTemplate} target="_blank">
                      {item.accessUrlTemplate}
                    </Link>
                  </>
                }
              />
            </List.Item>
          )}
        />

        <Divider />

        {/* <Title level={5}>
          <DatabaseOutlined />
          &nbsp;Create a new Managed Resource Type
        </Title> */}

        <ManagedResourceTypeEditModal
          title="Create a new Managed Resource Type"
          icon={<PlusOutlined />}
          buttonText="Create new"
          // form={form}
          initialValues={{
            applicationSubscriptionId: applicationSettings?.id,
            initialState: "Active",
          }}
          onFinish={onCreateFinish}
          onFinishFailed={onCreateFinishFailed}
        />

        <HelpManagedResourceType />
      </div>
    );
};

ServiceApplicationManagedResourceTypeAdmin.propTypes = {
  getServiceApplicationsInServiceCollection: PropTypes.func.isRequired,
  getServiceCollection: PropTypes.func.isRequired,
  getApplicationListV2: PropTypes.func.isRequired,
  getServiceApplicationSubscriptionSettings: PropTypes.func.isRequired,
  postCreateManagedResourceType: PropTypes.func.isRequired,
  putUpdateManagedResourceType: PropTypes.func.isRequired,
  deleteManagedResourceType: PropTypes.func.isRequired,
  serviceApplications: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getManagedResourceTypesInApplication: PropTypes.func.isRequired,
  resourceTypes: PropTypes.array,
  loading: PropTypes.bool,
  serviceCollection: PropTypes.object,
  applications: PropTypes.array,
  applicationSettings: PropTypes.object,
};

export default connect(
  (state) => ({
    serviceCollection: state.serviceCollection.data,
    applications: state.applications.data,
    serviceApplications: state.serviceApplications.data,
    applicationSettings: state.serviceApplicationSubscriptionSettings.data,
    isLoading: state.serviceApplications.loading,
    resourceTypes: state.managedResourceTypes.data,
    loading: state.managedResourceTypes.loading,
  }),
  {
    getServiceApplicationsInServiceCollection,
    getServiceCollection,
    getApplicationListV2,
    getServiceApplicationSubscriptionSettings,
    postCreateManagedResourceType,
    putUpdateManagedResourceType,
    deleteManagedResourceType,
    getManagedResourceTypesInApplication,
  },
)(ServiceApplicationManagedResourceTypeAdmin);
